import axios from "src/lib/axios";
import { AppThemeData, MasterModel, ThemeComponent } from "./Types";
import AlertMessage from "src/components/ui-components/AlertMessage";

const API_URLS = {
  GET_THEME_COMPONENT: `/AppTheme/GetThemeComponents`,
  GET_THEME_PROPERTIES: `/AppTheme/GetThemePropertiesForApp`,
  GET_CONFIG_THEME_SETTINGS: `/AppTheme/GetConfigThemeSettings`,
  GET_FONT_FAMILY_MASTER: `/FontFamilyMaster/GetFontFamilyMaster`,
  GET_FONT_WEIGHT_MASTER: `/FontWeightMaster/GetFontWeightMaster`,
  GET_FONT_SIZE_MASTER: `/FontSizeMaster/GetFontSizeMaster`,
  GET_ICON_SIZE_MASTER: `/IconSizeMaster/GetIconSizeMaster`,
  UPDATE_APP_THEME: `/AppTheme/UpdateAppTheme`
};

export const GetThemeComponent = async () => {
  try {
    const response = await axios.get<ThemeComponent[]>(API_URLS.GET_THEME_COMPONENT);
    return response?.data  || [];
  } catch {
    return [];
  }
};

export const GetAppThemeProperties = async () => {
  try {
    const response = await axios.get<AppThemeData>(API_URLS.GET_THEME_PROPERTIES);
    return response?.data  || [];
  } catch {
    return [];
  }
};

export const GetConfigThemeSettings = async () => {
  try {
    const response = await axios.get(API_URLS.GET_CONFIG_THEME_SETTINGS);
    return response?.data  || {};
  } catch {
    return {};
  }
};

export const getFontFamilyMaster = async(): Promise<MasterModel[]> => {
  const response = await axios.get<MasterModel[]>(API_URLS.GET_FONT_FAMILY_MASTER);
  return response?.data || [];
};

export const getFontWeightMaster = async(): Promise<MasterModel[]> => {
  const response = await axios.get<MasterModel[]>(API_URLS.GET_FONT_WEIGHT_MASTER);
  return response?.data || [];
};

export const getFontSizeMaster = async(): Promise<any> => {
  const response = await axios.get(API_URLS.GET_FONT_SIZE_MASTER);
  return response?.data || [];
};

export const getIconSizeMaster = async(): Promise<any> => {
  const response = await axios.get(API_URLS.GET_ICON_SIZE_MASTER);
  return response?.data || [];
};

export const updateAppTheme = async (data: AppThemeData): Promise<any> => {
  try {
    const response = await axios.post<any>(API_URLS.UPDATE_APP_THEME, data);
    if (response?.data?.isSuccess) {
      AlertMessage({type: 'success', msg:response.data.message});
      return true;
    } else {
      return false;
    }
  } catch {
    AlertMessage({ type: 'error', msg: 'Failed to update Theme'});
    return false;
  }
};